export default __webpack_public_path__ + "static/media/star.f47b86a4.svg";